import { render, staticRenderFns } from "./SessionDetails.vue?vue&type=template&id=26964b4f&scoped=true&"
import script from "./SessionDetails.vue?vue&type=script&lang=js&"
export * from "./SessionDetails.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SessionDetails.vue?vue&type=style&index=1&id=26964b4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26964b4f",
  null
  
)

export default component.exports